import Util from '@/assets/libs/util'
import requesModule from '@/assets/libs/requestModule'

const EVENT_READ_CARD = '/ReadCardSerialNumber'
const LRFID_TYPE = 7
const NO_CARD = '00000000'
const MILLISECONDS = 1000

let intervalID = null

const stopListeningForRfid = () => {
    if (!Util.isAndroidMode() && Util.isTapMode()) {
        clearInterval(intervalID)
        intervalID = null
    }
}

const listenForRfid = (callback) => {
    if (!Util.isAndroidMode() && Util.isTapMode()) {
        intervalID = setInterval(checkCardSerialNumber, MILLISECONDS, callback)
    }
}

const checkCardSerialNumber = async function (callback) {
    let response = await readCardSerialNumber()
    if (response && !response.error && response.cardSerialNumber !== NO_CARD) {
        callback(response.cardSerialNumber)
    }
}

const readCardSerialNumber = () => {
    try {
        let payload = {
            LRFidType: LRFID_TYPE
        }
        return requesModule.curlRequest(EVENT_READ_CARD, payload).then(r => r.data)
    } catch (error) {
        logError(error)
        return null
    }
}

const logError = (error) => {
    let message = error.message
    Util.logComunication('Exception ', {}, message)
}

export default {
    listenForRfid,
    stopListeningForRfid
}



// WEBPACK FOOTER //
// ./src/assets/controllers/RfidController.js